module.exports = __webpack_public_path__ + "img/Wossten.1fb045d7.jpg";